<template>
  <div>
    <div class="order1">
      <div class="order1-text">沃享·懂私域·更懂你</div>
      <div class="order1-des">他们都在用（排名不分先后）</div>
    </div>
    <div class="order5">
      <img src="@i/img/partner.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.order5 img {
  width: 100%;
}
.order1 {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}
.order1-text {
  margin: 0 auto;
  font-size: 30px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #1466da;
  line-height: 2.78rem;
}
.order1 .order1-des {
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 300;
  color: #313945;
  line-height: 1.87rem;
  padding: 10px 0 0 0;
}
@media screen and (max-width: 400px) {
  .order1-text {
    font-size: 20px;
  }
}
</style>